var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576-144q-112 0-198-64T258-372h-78q-15 0-25.5-10.5T144-408q0-15 10.5-25.5T180-444h62q-2-14-2-32t2-40h-62q-15 0-25.5-10.5T144-552q0-15 10.5-25.5T180-588h78q34-100 120-164t198-64q61 0 115 20t98 56q11 10 12 24.5T791-690q-11 11-26.5 11T737-689q-34-26-74.5-40.5T576-744q-81 0-145.5 43.5T335-588h205q15 0 25.5 10.5T576-552q0 15-10.5 25.5T540-516H314q-2 11-2.5 29.5T314-444h226q15 0 25.5 10.5T576-408q0 15-10.5 25.5T540-372H335q31 69 95.5 112.5T576-216q46 0 86.5-14.5T737-271q12-10 27-10.5t26 10.5q11 11 10.5 26T789-220q-44 36-98 56t-115 20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.10b65d523432b6746262574e437ad224.svg";
export { ForwardRef as ReactComponent };